<template>
  <div class="_container _light">
    <div class="_insideContainer">
      <Title :title="title" :tag="head" type="light" />
      <div class="aimsContainer" data-aos="fade-right">
        <div class="_content" style="margin-bottom:30px;"><strong>Misyonumuz:</strong><br><br>{{ data.misyon || 'Yükleniyor...' }}</div>
      </div>
      <div class="aimsContainer" data-aos="fade-right" data-aos-delay="100">
        <div class="_content"><strong>Vizyonumuz:</strong><br><br>{{ data.vizyon || 'Yükleniyor...' }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import Title from "../common/Title.vue";
export default { props: { head: String, title: String, data: Object }, components: { Title } };
</script>

<style scoped>
._container { width: 100%; display: flex; justify-content: center; padding: 0 5% 100px 5%; background-color: white;}
._insideContainer { width: 100%; max-width: 1900px; }
.aimsContainer { display: flex; font-family: "DM Sans", sans-serif; color: black; margin-bottom: 20px; }
._content { font-size: 18px; font-weight: 400; line-height: 1.6; }
@media screen and (max-width: 1023px) { ._content { font-size: 15px; } }
</style>